import { Expose } from "class-transformer";
import DriverRes from "./DriverRes";

export default class LoginRes {
  @Expose() readonly accessToken!: string;
  @Expose() readonly driver!: DriverRes;
}
